export const bgColor = '210458'